import { getUnreadNotificationCount } from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export function useHomeMobileTopBar() {
  const { lang } = useContext(PspContext);
  const navigate = useNavigate();

  const [hasNewNotification, setHasNewNotification] = useState(false);
  useEffect(() => {
    getUnreadNotificationCount().then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
      } else {
        setHasNewNotification(data > 0);
      }
    });
  }, [lang]);

  function onClickNotifications() {
    navigate("/notifications");
  }
  function onClickCalendar() {
    navigate("/calendar");
  }
  function onClickMessages() {
    navigate("/messages");
  }

  return {
    onClickNotifications,
    onClickCalendar,
    hasNewNotification,
    onClickMessages,
  };
}
